import { useEffect } from "react";
import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HomeFeatures from "./components/HomeFeatures";
import HomeFAQ from "./components/HomeFAQ";
import HomeArticles from "./components/HomeArticles";
import HomeCTA from "./components/HomeCTA";

export default function Home() {
  useEffect(() => {
    document.documentElement.lang = "zh-CN";
  }, []);

  const homeSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "JM网页版官网入口",
      url: "https://jm-official.com",
      description:
        "JM网页版官网入口，提供最新官方网页版登录地址，一键直达JM官网入口，无需下载APP即可访问，安全稳定的JM网页版通道。",
      contactPoint: {
        "@type": "ContactPoint",
        email: "support@jm-official.com",
        telephone: "400-XXX-XXXX",
        contactType: "customer service",
        availableLanguage: "Chinese",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "JM网页版官网入口",
      url: "https://jm-official.com",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://jm-official.com/search?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "JM网页版官网入口 - 官方直达登录通道",
      description:
        "JM网页版官网入口，提供最新官方网页版登录地址，一键直达JM官网入口，无需下载APP即可访问，安全稳定的JM网页版通道。",
      url: "https://jm-official.com",
    },
  ];

  return (
    <>
      <SEOHead
        title="首页"
        description="JM网页版官网入口，提供最新官方网页版登录地址，一键直达JM官网入口，无需下载APP即可访问，安全稳定的JM网页版通道。收藏本页获取最新可用入口地址。"
        keywords="jm网页版官网入口,jm官网入口,jm网页版登录,jm官方入口,jm最新入口,jm网页版地址,jm直达入口"
        canonicalUrl="/"
        schemaData={homeSchema}
      />

      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%20in%20soft%20golden%20amber%20and%20cream%20tones%2C%20minimalist%20geometric%20patterns%2C%20smooth%20texture%2C%20elegant%20and%20modern%20design%2C%20subtle%20light%20effects%2C%20clean%20composition&width=1800&height=900&seq=hero-bg-home&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/25"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 lg:px-8 text-center py-20">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm mb-6">
              <div className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></div>
              <span className="text-xs font-medium text-foreground-700">
                官方认证 · 安全稳定 · 实时更新
              </span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight">
              JM网页版官网入口
              <br />
              <span className="text-accent-300">官方直达登录通道</span>
            </h1>

            <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-2xl mx-auto leading-relaxed">
              提供最新官方网页版登录地址，一键直达JM官网入口，无需下载APP即可访问，安全稳定的JM网页版通道，收藏本页获取最新可用入口地址。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10">
              <a
                href="#jm-entry"
                id="jm-entry"
                className="px-8 py-3.5 bg-accent-500 text-background-50 rounded-lg text-sm md:text-base font-semibold hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-[0_0_30px_rgba(0,0,0,0.15)]"
              >
                立即访问JM官网入口
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="#features"
                className="px-8 py-3.5 border border-background-50/30 text-background-50 rounded-lg text-sm md:text-base font-semibold hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </a>
            </div>

            <div className="flex items-center justify-center gap-6 text-background-50/60">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50">
                  500万+
                </div>
                <div className="text-xs md:text-sm">月活跃用户</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50">
                  99.9%
                </div>
                <div className="text-xs md:text-sm">服务可用率</div>
              </div>
              <div className="w-px h-10 bg-background-50/20"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-background-50">
                  7年+
                </div>
                <div className="text-xs md:text-sm">稳定运营</div>
              </div>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
        </section>

        {/* Entry Cards */}
        <section id="jm-entry" className="py-14 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
            <div className="text-center mb-10">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
                官方入口
              </span>
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                JM网页版官方直达入口
              </h2>
              <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
                以下所有入口均经过官方认证，请放心使用。建议收藏本页面以便随时获取最新地址。
              </p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {[
                {
                  title: "JM网页版官网入口",
                  desc: "官方主入口地址，推荐首选使用",
                  icon: "ri-home-4-line",
                  highlight: true,
                  seq: "entry-card-main",
                },
                {
                  title: "JM网页版备用入口",
                  desc: "主入口维护时的备用通道",
                  icon: "ri-git-branch-line",
                  highlight: false,
                  seq: "entry-card-backup",
                },
                {
                  title: "JM网页版镜像入口",
                  desc: "CDN加速镜像节点，访问更快速",
                  icon: "ri-global-line",
                  highlight: false,
                  seq: "entry-card-mirror",
                },
              ].map((entry, idx) => (
                <div
                  key={idx}
                  className={`relative rounded-xl border-2 overflow-hidden transition-all duration-300 cursor-pointer ${
                    entry.highlight
                      ? "border-accent-500 bg-accent-50/50 hover:shadow-[0_0_25px_rgba(0,0,0,0.08)]"
                      : "border-background-200/70 bg-background-50 hover:border-accent-300"
                  }`}
                >
                  {entry.highlight && (
                    <div className="absolute top-3 right-3 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-semibold rounded-md">
                      推荐
                    </div>
                  )}
                  <div className="p-6 md:p-7">
                    <div className="w-12 h-12 flex items-center justify-center bg-accent-100 rounded-xl mb-4">
                      <i
                        className={`${entry.icon} text-xl text-accent-600`}
                      ></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-950 mb-2">
                      {entry.title}
                    </h3>
                    <p className="text-sm text-foreground-600 mb-5">
                      {entry.desc}
                    </p>
                    <a
                      href="#"
                      className={`inline-flex items-center gap-1.5 text-sm font-semibold whitespace-nowrap cursor-pointer ${
                        entry.highlight
                          ? "text-accent-600 hover:text-accent-700"
                          : "text-foreground-700 hover:text-accent-600"
                      }`}
                    >
                      立即访问
                      <i className="ri-arrow-right-up-line"></i>
                    </a>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-6 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-secondary-100 rounded-lg flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-secondary-600"></i>
                </div>
                <div>
                  <p className="text-sm text-foreground-700 font-medium mb-1">
                    温馨提示
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    请将本页面加入浏览器收藏夹（Ctrl+D），以便随时获取JM网页版最新入口地址。如遇入口地址变更，我们会第一时间更新。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <HomeFeatures />
        <HomeFAQ />
        <HomeArticles />
        <HomeCTA />
      </main>

      <Footer />
    </>
  );
}